jQuery( document ).ready(function($) {
if ($(".single-restaurant").exist()){

	//---------------------------
	// Save plat
	//---------------------------
	
	var all_plats = JSON.parse($(".single-restaurant .plats_list").attr('all_plats'));

	var $add_new_wrap = $(".single-restaurant .add_new_wrap");
	$(".single-restaurant .add_new_button").click(function(){
		open_new_plat_form();
	});


	//close form
	$add_new_wrap.mousedown(function(data, handler){
		if (data.target == this) {		
			close_new_plat_form();
		}
	});
	$(".single-restaurant .add_new .close").click(function(){
		close_new_plat_form();
	});

	function open_new_plat_form() {
        $add_new_wrap.addClass("active");
    }
    function close_new_plat_form() {
		$add_new_wrap.removeClass("active");
		reset_plat_form();
	}
	function reset_plat_form() {
		$add_new_wrap.find('.input').html('');
		$add_new_wrap.find('input[type=text] ,input[type=hidden] ').val('');
	}
	
	var input_selector = {
		'id' : $add_new_wrap.find(".input_id "),
		'title' : $add_new_wrap.find(".input_title "),
		'comment' : $add_new_wrap.find(".input_comment "),
		'note_papa' : $add_new_wrap.find(".input_note_papa "),
		'note_maman' : $add_new_wrap.find(".input_note_maman "),
		'note_theo' : $add_new_wrap.find(".input_note_theo "),
		'gallery' : $add_new_wrap.find(".file_picker_value "),
	}

	$('.single-restaurant .add_new_wrap .submit').click(function() {
		
		var form_data = {
			'post_id' : $add_new_wrap.attr("post_id"),
		}
		for (var i in  input_selector){
			form_data[i] = (  input_selector[i].is('input') ?  input_selector[i].val() :  input_selector[i].html() );
		}

		$.ajax({
			type: "POST",
			dataType: "json",
			url: ajaxurl,
			data: {
                action: "add_plat",
                form_data: form_data
            }
		}).done(function(response) {
			//console.log(data);
			if (response['status'] == 'success'){
				close_new_plat_form();

				all_plats[response['data']['plat']['id']] = response['data']['plat'];

				if (form_data['id'] != ''){ //edit
					$('.plats_list .plat_item[plat_id="'+response['data']['plat']['id']+'"]').replaceWith(response['data']['html']);
					var $el =$('.plats_list .plat_item[plat_id="'+response['data']['plat']['id']+'"]');
				}else{ //new
					var $el = $('.plats_list tbody').append(response['data']['html']);
				}
				load_action($el);
				
			}
			
		})
	});

	function load_action($el){

		$el.find('.edit').click(function(){
			load_plat($(this).closest('.plat_item').attr('plat_id'));	
			open_new_plat_form();
		});
		$el.find('.delete').click(function(){
			delete_plat($(this).closest('.plat_item').attr('plat_id'));		
		});
	}
	

	function load_plat(plat_id){
		for (var col in  input_selector){

			if (input_selector[col].is('input')){
				input_selector[col].val(all_plats[plat_id][col]);
			}else{
				input_selector[col].html(all_plats[plat_id][col]);
			}

		}

	}
	function delete_plat(plat_id){
		if (confirm("delete ?") == true) {
			var form_data = {
				'plat_id' : plat_id
			};
			$.ajax({
				type: "POST",
				dataType: "json",
				url: ajaxurl,
				data: {
					action: "delete_plat",
					form_data: form_data
				}
			}).done(function(response) {
				if (response['status'] == 'success'){						
					$('.plats_list .plat_item[plat_id="'+response['data']['plat_id']+'"]').remove();					
				}
				
			})
		}
	}

	$('.single-restaurant .plat_item').each(function(){
		load_action($(this));		
	});

	//init




	
}//end if exist
});
